import axios from '@/libs/api.request.js';

const tenant = {
    // 获取商户信息
    getTenantInfo: () => {
        return axios.get({
            url: '/wap/Tenant'
        })
    }
};

export default tenant;


// WEBPACK FOOTER //
// ./src/api/api-tenant.js